var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.$Base.checkSysteam() == 'MOBILE' ? 'm-rastar-verified' : 'rastar-verified'},[(_vm.loading)?_c('rastar-loading'):_vm._e(),_c('iframe',{ref:"iframe",attrs:{"src":_vm.verifiedUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }